import React, { useEffect } from "react";
import { Modal, Divider, App } from "antd";
import { makeStyles } from "@material-ui/core/styles";
import { Button, InputAdornment, OutlinedInput } from "@material-ui/core";
import config from "../../config";
import { useSelector } from "react-redux";
import { useCountry } from "../../provider/courtryProvider";

const useStyles = makeStyles((theme) => ({
  dividerStyle: {
    marginTop: 14,
    marginBottom: 14,
    border: "0.5px solid #909090",
  },
  modalStyle: {
    "& .ant-modal-content": {
      borderRadius: "2rem",
    },
  },
  ButtonStyle: {
    backgroundColor: "#EF4667",
    color: "#fff",
    border: 0,
    borderRadius: "4px",
    paddingLeft: "34px",
    paddingRight: "34px",
    "&:hover": {
      backgroundColor: "#EF4667",
      color: "#fff",
    },
  },
  selectStyle: {
    "& legend": {
      display: "none",
    },
  },
  inputStyle: {
    "& label": {
      display: "none",
    },
  },
}));
const StartCounterModal = ({ open, setOpen, setCounterId }) => {
  const classes = useStyles();
  const shopId = useSelector((state) => state.shopDetails.shopId);
  const employeeId = useSelector((state) => state.shopDetails.empId);
  const { message } = App.useApp();
  const [startCounterBalance, setStartCounterBalance] = React.useState("");
  const country = useCountry();
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("startCounterBalance", startCounterBalance);
    if (!startCounterBalance) {
      return message.error("Please enter opening balance");
    }

    try {
      var response = await fetch(`${config.newApiGateway}/counter/counter`, {
        method: "post",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-type": "application/json",
        },
        body: JSON.stringify({
          openBalance: startCounterBalance,
          employeeId: employeeId ? employeeId : "",
          shopId,
          type: "start",
          counterOpenedTime: new Date().toLocaleTimeString("en-IN", {
            hour: "2-digit",
            minute: "2-digit",
          }),
        }),
      });
      const res = await response.json();
      console.log("ressdsdsd", res);
      if (res.code === "SUCCESS") {
        setOpen(false);
        setCounterId(res.data.counterId);
        console.log("res.counterId", res.data.counterId);
      }
      if (res.code === "ERROR") {
        return alert(res.message);
      }
    } catch (err) {
      console.log("ERR", err);
    }
  };

  return (
    <>
      <Modal
        open={open}
        footer={false}
        centered
        className={classes.modalStyle}
        width={700}
        closable={false}
      >
        <form onSubmit={handleSubmit}>
          <h3
            style={{
              color: "#EF4667",
            }}
          >
            Start Counter
          </h3>
          <Divider className={classes.dividerStyle} />

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "2rem",
            }}
          >
            <div>Start Counter</div>
            <OutlinedInput
              startAdornment={
                <InputAdornment position="start">
                  {country.CurrencySymbol}
                </InputAdornment>
              }
              onChange={(e) => setStartCounterBalance(e.target.value)}
              type="number"
            />
          </div>
          <Divider className={classes.dividerStyle} />
          <Button
            style={{
              background: "#EF4667",
              width: "100%",
              color: "#fff",
            }}
            type="submit"
            size="large"
          >
            Submit
          </Button>
        </form>
      </Modal>
    </>
  );
};

export default StartCounterModal;
